import {
  ToolIconFrame,
  toolIconPrimary,
  toolIconSecondary,
  type ToolIconProps
} from './ToolIconFrame';

export function PageAnalyzeIcon(props: ToolIconProps) {
  return (
    <ToolIconFrame strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path
        stroke={toolIconPrimary}
        strokeWidth="3"
        d="M4 28C4 17.028 13.028 8 24 8s20 9.028 20 20v10.5H4Z"
      />
      <path
        stroke={toolIconPrimary}
        strokeWidth="4"
        d="M9.495 27h.01m4.24-8.25h.01m10.24-4.25h.01m10.24 4.25h.01m4.24 8.25h.01"
      />
      <path
        stroke={toolIconSecondary}
        strokeWidth="4"
        d="m24.118 31.103 7.044-8.248"
      />
      <circle cx="24.118" cy="31.103" r="4.2" fill={toolIconSecondary} />
    </ToolIconFrame>
  );
}
